import { render, staticRenderFns } from "./HireSpecialistStar.vue?vue&type=template&id=6f21ec30&scoped=true&"
import script from "./HireSpecialistStar.vue?vue&type=script&lang=js&"
export * from "./HireSpecialistStar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f21ec30",
  null
  
)

export default component.exports